import { header } from "./_header.js";
import { toast } from "./_toast.js";
import { pulldown } from "./_pulldown.js";
import { textarea } from "./_textarea.js";
import { select } from "./_select.js";
import { inputPassword } from "./_inputPassword.js";
import { scrollContents } from "./_scrollContents.js";
import { inputAutoChange } from "./_inputAutoChange.js";
import { validation } from "./_validation.js";
import { tableControl } from "./_tableControl.js";
import { searchTable } from "./_searchTable.js";
import { searchForm } from "./_searchForm.js";
import { inputBranch } from "./_inputBranch.js";
import { fileUpload } from "./_fileUpload.js";
import { schoolSearch } from "./_schoolSearch.js";
import { checkTable } from "./_checkTable.js";
import { searchUser } from "./_searchUser.js";
import { searchUser2 } from "./_searchUser2.js";
import { searchProduct } from "./_searchProduct.js";
import { formAcc } from "./_formAcc.js";
import { formPopup } from "./_formPopup.js";
import { changeform } from "./_changeform.js";

/**
 * 全ページで使用する関数を呼び出す
 * @returns { void }
 */
export const commonFunc = () => {
  header();
  toast();
  pulldown();
  textarea();
  select();
  inputPassword();
  scrollContents();
  inputAutoChange();
  changeform();
  validation();
  tableControl();
  searchTable();
  searchForm();
  formAcc();
  formPopup();
  inputBranch();

  /**
   * ユーザー検索 ページ
   */
  if ( document.querySelector( '.p-search.is--user' ) !== null ) {
    searchUser();
  }
  if ( document.querySelector( '.p-search.is--user2' ) !== null ) {
    searchUser2();
  }

  /**
   * 商品検索 ページ
   */
  if ( document.querySelector( '.p-search.is--product' ) !== null ) {
    searchProduct();
  }

  /**
   * （新規）必要書面アップロード_書類アップロード ページ
   */
  if ( document.querySelector( '.p-form-item__file' ) !== null ) {
    fileUpload();
  }

  /**
   * 学校検索 ページ
   */
  if ( document.querySelector( '.js-schoolSearch' ) !== null ) {
    schoolSearch();
  }

  /**
   * 申込情報照会ページ（テーブル）
   */
  if ( document.querySelector( '.p-search-table.is--check' ) !== null ) {
    checkTable();
  }
}
